import React from "react";
import Headers from "../../../components/Headers";
import { Input, Row, Col, Button, Table, DatePicker, Modal } from "antd";
import NProgress from "nprogress";
import { fetchGrantRecord } from "../../../api/grantRecord";
import "./index.scss";
const { RangePicker } = DatePicker;
const { Column } = Table;
const BreadCrumbData = [
  { path: "/replenishment/grantRecord", name: "派样记录" },
];
class GrantRecord extends React.Component {
  state = {
    listQuery: {
      pageNum: 1,
      pageSize: 10,
      brandName: "",
      materialsName: "",
      beginTime: "",
      endTime: "",
      companyName: "",
      mobilePhone: "",
    },
    total: 0,
    list: [],
    bigImgUrl: "",
    bigImgVisible: false,
  };
  showBigImg = (url) => {
    this.setState({
      bigImgVisible: true,
      bigImgUrl: url,
    });
  };
  handleExport = () => {
    let info = this.state.listQuery;
    let str = "";
    Object.keys(info).forEach((item) => {
      str = str + item + "=" + info[item] + "&";
    });
    str =
      str +
      "accessToken=" +
      JSON.parse(sessionStorage.getItem("loginInfo")).accessToken;
    window.open(
      process.env.REACT_APP_API_PREFIX + "web/record/list/export?" + str
    );
  };
  handleChange = (e) => {
    this.setState({
      listQuery: {
        ...this.state.listQuery,
        [e.target.name]: e.target.value,
      },
    });
  };
  componentDidMount() {
    NProgress.start();
    this.getList();
    NProgress.done();
  }
  handleSearch = () => {
    this.setState(
      {
        listQuery: {
          ...this.state.listQuery,
          pageNum: 1,
        },
      },
      () => {
        this.getList();
      }
    );
  };
  getList = () => {
    fetchGrantRecord(this.state.listQuery).then((res) => {
      if (res.success) {
        if (res.data.list) {
          this.setState({
            list: res.data.list,
            total: res.data.total,
          });
        }
      }
    });
  };
  dateChange = (date, dateString) => {
    this.setState({
      listQuery: {
        ...this.state.listQuery,
        beginTime: dateString[0],
        endTime: dateString[1],
      },
    });
  };

  // 查看问卷详情
  viewQuestion = (record) => {
    this.props.history.push("/page/ssry/viewQuestion/" + record.recordNo);
  };

  // 查看测评详情
  toDetail = (record) => {
    this.props.history.push(`/page/ssry/questionnaire/${record.tryRecordId}`);
  };

  render() {
    const { listQuery, list, total, bigImgVisible, bigImgUrl } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="grant_container">
          <Row style={{ marginBottom: 8 }} className="card_container">
            <Col span={22}>
              <RangePicker
                className="marginR"
                onChange={this.dateChange}
                style={{ width: 250 }}
              />
              <Input
                allowClear
                name="mobilePhone"
                onChange={this.handleChange}
                className="marginR"
                style={{ width: 140 }}
                value={listQuery.mobilePhone}
                placeholder="用户手机号码"
              ></Input>
              <Input
                allowClear
                name="companyName"
                onChange={this.handleChange}
                className="marginR"
                style={{ width: 140 }}
                value={listQuery.companyName}
                placeholder="商户名称"
              ></Input>
              <Input
                allowClear
                name="brandName"
                onChange={this.handleChange}
                className="marginR"
                style={{ width: 140 }}
                value={listQuery.brandName}
                placeholder="品牌商名称"
              ></Input>
              <Input
                allowClear
                name="materialsName"
                onChange={this.handleChange}
                className="marginR"
                style={{ width: 140 }}
                value={listQuery.materialsName}
                placeholder="商品名称"
              ></Input>
              <Button onClick={this.handleSearch} type="primary">
                搜索
              </Button>
            </Col>
            <Col span={2}>
              <Button className="fr" onClick={this.handleExport} type="primary">
                导出
              </Button>
            </Col>
          </Row>
          <div className="card_container">
            <Table
              dataSource={list}
              rowKey="recordNo"
              pagination={{
                showTotal: () => `共${total}条`,
                total: total,
                current: listQuery.pageNum,
                pageSize: listQuery.pageSize,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["10", "20", "30", "40", "100"],
                onChange: (page, pageSize) => {
                  this.setState(
                    {
                      listQuery: { ...listQuery, pageNum: page },
                    },
                    () => this.getList()
                  );
                },
                onShowSizeChange: (current, pageSize) => {
                  this.setState(
                    {
                      listQuery: { ...listQuery, pageSize, pageNum: 1 },
                    },
                    () => this.getList()
                  );
                },
              }}
            >
              <Column
                title="派样时间"
                dataIndex="createTime"
                key="createTime"
              />
              <Column title="用户昵称" dataIndex="nickName" key="nickName" />
              <Column
                title="用户手机号码"
                dataIndex="mobilePhone"
                key="mobilePhone"
              />
              <Column
                title="所属商户"
                dataIndex="companyName"
                key="companyName"
              />
              <Column title="设备编号" dataIndex="capsuleNo" key="capsuleNo" />
              <Column title="设备地点" dataIndex="address" key="address" />
              {/* <Column title="货道号" dataIndex="aisleNo" key="aisleNo" /> */}
              <Column
                title="运营商名称"
                dataIndex="operatorCompanyName"
                key="operatorCompanyName"
              />
              <Column
                title="品牌商名称"
                dataIndex="brandName"
                key="brandName"
              />
              <Column
                title="商品名称"
                dataIndex="materialsName"
                key="materialsName"
              />
              <Column
                title="商品图片"
                dataIndex="pic"
                key="pic"
                render={(text) => (
                  <img
                    onClick={() => this.showBigImg(text)}
                    style={{ width: 40, height: 40, cursor: "pointer" }}
                    src={text}
                  ></img>
                )}
              />
              <Column
                width="100px"
                title="出货状态"
                key="state"
                render={(text, record) => {
                  return (
                    <span>
                      {record.state == "SUCCESS" ? (
                        <a style={{ color: "#63B607" }}>出货成功</a>
                      ) : (
                        <a style={{ color: "#F5A623" }}>出货失败</a>
                      )}
                    </span>
                  );
                }}
              />
              <Column
                width="100px"
                title="测评信息"
                key="questionnaireState"
                render={(text, record) => {
                  return (
                    <span>
                      {
                        record.questionnaireState === 1 ? (
                          <a>
                            {record.form === 1 ? (
                              <a onClick={() => this.viewQuestion(record)}>查看问卷</a>
                            ) : (
                              <a onClick={() => this.toDetail(record)}>查看测评</a>
                            )}
                          </a>
                        ) : (
                          <a style={{ color: "rgba(0,0,0,.45)" }}>暂未提交</a>
                        )
                      }

                    </span>
                  );
                }}
              />
            </Table>
          </div>
        </div>
        <Modal
          title="图片预览"
          onCancel={() => this.setState({ bigImgVisible: false })}
          visible={bigImgVisible}
          footer={null}
        >
          <img style={{ width: "100%", height: "100%" }} src={bigImgUrl}></img>
        </Modal>
      </div>
    );
  }
}
export default GrantRecord;
